<template>
  <div>
      <ul class="tree" style="display:block;" v-for="listTreeCategories in listCategories" v-bind:key="listTreeCategories.id">
        <li>
          <input type="checkbox" class="inputCheckTree" :id="'c' + listTreeCategories.id" v-if="listTreeCategories.categoriesList.length > 0"/>
        
          <label class="tree_label" :for="'c' + listTreeCategories.id">
          <!--input type="checkbox" class="inputCheck" :checked="listTreeCategories.checked" :id="'inputCheck' + listTreeCategories.id" :data-id-categories="listTreeCategories.id" @click="checkCategories(listTreeCategories.id)"/-->
          {{ listTreeCategories.code }} - {{ listTreeCategories.description }}
          
          <i class="fa fa-eye icons-detail" title="Clicca per mettere la categoria offline" v-if="listTreeCategories.online" style="color:#1EA076;cursor:pointer;" @click="changeOnline(listTreeCategories.id, listTreeCategories.online, true)"></i>
          <i class="fa fa-eye icons-detail" title="Clicca per mettere la categoria online" v-else style="color:#D44950;cursor:pointer;" @click="changeOnline(listTreeCategories.id, listTreeCategories.online, true)"></i>
          
          <i class="fa fa-chevron-circle-down icons-detail icon-category" title="Clicca per aumentare l'ordinamento" style="cursor: pointer;margin-left: 5px;color: #20A8D8;float:right;" @click="changeOrderDown(listTreeCategories.category_father_id, null, listTreeCategories.order, true)"></i>
          <i class="fa fa-chevron-circle-up icons-detail icon-category" title="Clicca per diminuire l'ordinamento" style="cursor: pointer;margin-left: 5px;color: #20A8D8;float:right;" @click="changeOrderUp(listTreeCategories.category_father_id, null, listTreeCategories.order, true)"></i>
          <router-link class="icon-category" style="float: right;" :to="'/admin/crm/Categories?id=' + listTreeCategories.id" target='_blank'><i class="fa fa-pencil-square-o icons-detail" title="Clicca per modificarne i dati" style="cursor: pointer;margin-left: 5px;color: #222;position: relative;top: 1px;"></i></router-link>
          </label>
          <TreeCategoriesMap :listCategories="listTreeCategories.categoriesList" v-if="listTreeCategories.categoriesList.length > 0"></TreeCategoriesMap>
          <div class="container-item" v-if="listTreeCategories.itemsList.length > 0">
            <div v-for="itemsLists in listTreeCategories.itemsList" v-bind:key="itemsLists.id">
              <label style="margin-top:2px;">
                {{ itemsLists.code }} - {{ itemsLists.description }}
              </label>
              <i class="fa fa-eye icons-detail" title="Clicca per mettere l'articolo offline" v-if="itemsLists.online" style="color:#1EA076;cursor:pointer;top: -1px;position: relative;" @click="changeOnline(itemsLists.item_id, itemsLists.online, false)"></i>
              <i class="fa fa-eye icons-detail" title="Clicca per mettere l'articolo online" v-else style="color:#D44950;cursor:pointer;top: -1px;position: relative;" @click="changeOnline(itemsLists.item_id, itemsLists.online, false)"></i>
              <i class="fa fa-chevron-circle-down icons-detail icon-item"  title="Clicca per aumentare l'ordinamento" style="cursor: pointer;margin-left: 5px;color: #20A8D8;top: 3px;position: relative;float:right;" @click="changeOrderDown(listTreeCategories.id, itemsLists.item_id, itemsLists.order, false)"></i>
              <i class="fa fa-chevron-circle-up icons-detail icon-item" title="Clicca per diminuire l'ordinamento"  style="cursor: pointer;margin-left: 5px;color: #20A8D8;top: 3px;position: relative;float:right;" @click="changeOrderUp(listTreeCategories.id, itemsLists.item_id, itemsLists.order, false)"></i>
              <router-link class="icon-item" style="float:right;" :to="'/admin/crm/Items?id=' + itemsLists.item_id" target='_blank'><i class="fa fa-pencil-square-o icons-detail" title="Clicca per modificarne i dati" style="cursor: pointer;margin-left: 5px;color: #222;position: relative;top: 3px;"></i></router-link>
            </div>
          </div>
        </li>
      </ul>
  </div>
</template>

<script>
import TreeCategoriesMap from "@/components/TreeCategoriesMap.vue";

export default {
  name: "TreeCategoriesMap",
  props: {
    listCategories: Array
  },
  data(){
    return{
    }
  },
  created: function(){
  },
  methods: {
    checkCategories(id){
      var listCategories = this;
      var checkedCategories = false;
      if($('#inputCheck' + id).is(':checked')){
        checkedCategories = true;
      }
      if(!functionHelpers.isValued(this.$parent.checkCategoriesClick)){
        if(!functionHelpers.isValued(this.$parent.$parent.checkCategoriesClick)){
          if(!functionHelpers.isValued(this.$parent.$parent.$parent.checkCategoriesClick)){
            if(!functionHelpers.isValued(this.$parent.$parent.$parent.$parent.checkCategoriesClick)){
              this.$parent.$parent.$parent.$parent.$parent.checkCategoriesClick(id, checkedCategories);
            }else{
              this.$parent.$parent.$parent.$parent.checkCategoriesClick(id, checkedCategories);
            }
          }else{
            this.$parent.$parent.$parent.checkCategoriesClick(id, checkedCategories);
          }
        }else{
          this.$parent.$parent.checkCategoriesClick(id, checkedCategories);
        }
      }else{
        this.$parent.checkCategoriesClick(id, checkedCategories);
      }
    },
    changeOnline(id, online, isCategories){
      var listCategories = this;
      if(!functionHelpers.isValued(this.$parent.changeOnlineCategory)){
        if(!functionHelpers.isValued(this.$parent.$parent.changeOnlineCategory)){
          if(!functionHelpers.isValued(this.$parent.$parent.$parent.changeOnlineCategory)){
            if(!functionHelpers.isValued(this.$parent.$parent.$parent.$parent.changeOnlineCategory)){
              this.$parent.$parent.$parent.$parent.$parent.changeOnlineCategory(id, online, isCategories);
            }else{
              this.$parent.$parent.$parent.$parent.changeOnlineCategory(id, online, isCategories);
            }
          }else{
            this.$parent.$parent.$parent.changeOnlineCategory(id, online, isCategories);
          }
        }else{
          this.$parent.$parent.changeOnlineCategory(id, online, isCategories);
        }
      }else{
        this.$parent.changeOnlineCategory(id, online, isCategories);
      }
    },
    changeOrderUp(id, idItem, order, isCategories){
      var listCategories = this;
      if(!functionHelpers.isValued(this.$parent.changeOrderCategoryFatherUp)){
        if(!functionHelpers.isValued(this.$parent.$parent.changeOrderCategoryFatherUp)){
          if(!functionHelpers.isValued(this.$parent.$parent.$parent.changeOrderCategoryFatherUp)){
            if(!functionHelpers.isValued(this.$parent.$parent.$parent.$parent.changeOrderCategoryFatherUp)){
              this.$parent.$parent.$parent.$parent.$parent.changeOrderCategoryFatherUp(id, idItem, order, isCategories);
            }else{
              this.$parent.$parent.$parent.$parent.changeOrderCategoryFatherUp(id, idItem, order, isCategories);
            }
          }else{
            this.$parent.$parent.$parent.changeOrderCategoryFatherUp(id, idItem, order, isCategories);
          }
        }else{
          this.$parent.$parent.changeOrderCategoryFatherUp(id, idItem, order, isCategories);
        }
      }else{
        this.$parent.changeOrderCategoryFatherUp(id, idItem, order, isCategories);
      }
    },
    changeOrderDown(id, idItem, order, isCategories){
      var listCategories = this;
      if(!functionHelpers.isValued(this.$parent.changeOrderCategoryFatherDown)){
        if(!functionHelpers.isValued(this.$parent.$parent.changeOrderCategoryFatherDown)){
          if(!functionHelpers.isValued(this.$parent.$parent.$parent.changeOrderCategoryFatherDown)){
            if(!functionHelpers.isValued(this.$parent.$parent.$parent.$parent.changeOrderCategoryFatherDown)){
              this.$parent.$parent.$parent.$parent.$parent.changeOrderCategoryFatherDown(id, idItem, order, isCategories);
            }else{
              this.$parent.$parent.$parent.$parent.changeOrderCategoryFatherDown(id, idItem, order, isCategories);
            }
          }else{
            this.$parent.$parent.$parent.changeOrderCategoryFatherDown(id, idItem, order, isCategories);
          }
        }else{
          this.$parent.$parent.changeOrderCategoryFatherDown(id, idItem, order, isCategories);
        }
      }else{
        this.$parent.changeOrderCategoryFatherDown(id, idItem, order, isCategories);
      }
    },
  }
};
</script>
<style scoped>
/*
  Tree styles
*/
.tree { 
  margin: 5px;
  padding-left: 12px;
  transition:all ease-in-out 0.25;
  margin-right: 0px;
}
.tree div{
  transition:all ease-in-out 0.25;
} 

.tree input.inputCheckTree {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  }

.tree input.inputCheckTree ~ div { 
  display: none;

  /* se serve effetto tutto albero esploso  mettere */
  /* display: block; */

  transition:all ease-in-out 0.25; 
}

.tree input.inputCheckTree:checked ~ div { 
  display: block;
  transition:all ease-in-out 0.25; 
}

/*
  Tree rows
*/
.tree li {
  line-height: 1.2;
  position: relative;
  padding: 0 0 5px 5px;
}

/*.tree ul li { padding:5px 0 0 5px; }*/

.tree > li:last-child { padding-bottom: 0; }

/*
  Tree labels
*/
.tree_label {
  white-space:nowrap;
  position: relative;
  display: inline-block;
  margin-bottom:0px;
  width:100%;
  padding: 2px 5px 2px 0px;
  /*margin-left: -20px;*/
}

label.tree_label {
    color: #303c54;
    font-size: 16px;
    font-weight: lighter;
}

label.tree_label:hover { color: #666; }

/* 
  Tree icon
*/
label.tree_label:before {
  font-family: "FontAwesome";
  color: #20a8d8;
  position: relative;
  z-index: 0;
  float: left;
  font-size:15px;
  margin:  5px 25px 0 -1em;
  border-radius: 1em;
  content: "\f07b";
  text-align: center;
  line-height: .9em;
  right:-20px;
  }

:checked ~ label.tree_label:before { 
  font-family: "FontAwesome";
  content: '\f07c';
}

/* 
  Tree branches
*/
.tree li:before {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -.5em;
  display: block;
  width: 0;
  content: "";
  }

.tree_label:after {
  position: absolute;
  top: 0;
  left: -1.5em;
  display: block;
  height: 0.5em;
  width: 1em;
  content: '';
  }

label.tree_label:after { border-bottom: 0; }

:checked ~ label.tree_label:after {
  bottom: 0;
  top: 0.5em;
  height: auto;
  }

.tree li:last-child:before {
  height: 1em;
  bottom: auto;
  }

.tree > li:last-child:before { display: none; }

.tree_custom {
  display: block;
  background: #eee;
  padding: 1em;
  border-radius: 0.3em;
}
li {
  list-style: none;
}
.inputCheck {
  margin-right:5px;
}

.fa-eye {
  margin-left:10px;
}

.icons-detail {
  font-size:20px;
}

.container-item div:before {
  font-family: "FontAwesome";
  color: #555;
  position: relative;
  z-index: 0;
  float: left;
  font-size:15px;
  margin: 5px 25px 0 -1em;
  border-radius: 1em;
  content: "\f15b";
  text-align: center;
  line-height: .9em;
  right:-20px;
}
.container-item{
    margin-top: 8px;
    margin-bottom: 5px;
    margin-left: 25px;
}
.container-item label{
  font-size: 15px;
  color: #303c54;
  max-width: 400px;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 0px;
}

.container-item .icon-item, .tree_label .icon-category{
  display: none;
  transition: all ease-in-out 0.25s;
}


.container-item div:hover .icon-item{
  display: block;
}
.container-item div:hover{
  background:#ededed;
}


.tree_label:hover .icon-category{
  display: block;
}
.tree_label:hover{
  background:#ededed;
}

.container-item div{    
  margin-bottom: 5px;
  padding-right: 5px;
}
</style>



